/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */
import { ReactComponent as DownArrow } from 'src/assets/icons/down-arrow.svg';
import React, { useState } from 'react';
import PageWrapper from 'src/components/PageWrapper';
import SimpleButton from 'src/components/SimpleButton';
import Switcher from 'src/components/Switcher';
import TitleInput from 'src/components/TitleInput';

import PageHolder from 'src/components/PageHolder';
import ConfirmModal from 'src/components/ConfirmModal';
import useToast from 'src/hooks/useToast';
import { useHistory } from 'react-router-dom';
import { chatgenieAPI } from 'src/config/api';
import useIsFeatureFlagEnabled from 'src/hooks/useIsFeatureFlagEnabled';
import featureFlags from 'src/constants/featureFlags';
import CustomMultiSelect from 'src/components/MessengerSettings/CustomMultiSelect';
import VariationList from './Variation/VariationList';
import VariationArguments from './Variation/VariationArguments';
import { SeparatorStyled, ToolsStyled } from '../../../containers/ConfigureFlow/style';
import {
  ApprovalContactTypeSelectWrapper,
  ApprovalIntentBlock,
  ApprovalIntentContactTypes,
  ApprovalIntentField,
  ApprovalIntentWrapper,
  ChatWrapper,
  IntentBlock,
  IntentContainer,
  IntentWrapper
} from './style';

import VariationDetails from './Variation/VariationDetails';
import { useIntent } from './useIntent';
import IntentReply from './Reply';
import Automation from './Automation';
import IntentTemplatesModal from './Templates';

const IntentScreen = () => {
  const {
    data,
    isLoading,
    variation,
    isUpserting,
    isDirty,
    handleAddNewVariation,
    handleDeleteVariation,
    handleDuplicateVariation,
    handleChangeAutomation,
    handleChangeApproval,
    handleApprovalsCompanyTypes,
    handleAddFormField,
    handleChangeFormField,
    handleTitleChange,
    handleIsActive,
    handleDescriptionChange,
    handleRemoveArgument,
    handleSelectVariation,
    handleSubmit,
    handleVariationNameChange,
    handleVisibilityScopeChange,
    handleClientsChange,
    handleReplyContentChange,
    handleChangeArgumentOrder,
    handleCompanyTypesChange,
    handleContactTypesChange,
    handleParentCompaniesChange,
    handleTopLevelsChange,
    handleTimeSavedChange,
    handleVariationToggle
  } = useIntent();

  const { toast } = useToast();
  const [unsavedModalOpen, setUnsavedModalOpen] = useState(false);
  const history = useHistory();
  const isApprovalsEnabled = useIsFeatureFlagEnabled(featureFlags.APPROVALS);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [templateSwitchModalOpen, setTemplateSwitchModalOpen] = useState(false);

  const externalReply = variation?.replies?.find(reply => reply.type === 'external') || {};
  const internalReply = variation?.replies?.find(reply => reply.type === 'internal') || {};

  const [confirmDeleteData, setConfirmDeleteData] = useState({
    variation: null,
    isConfirming: false
  });

  const handleAttemptDelete = item => {
    if (item.is_default) {
      toast.error(`You could not delete default variation, try to delete whole intent`);
      return;
    }
    setConfirmDeleteData({ variation: item, isConfirming: true });
  };

  const getContactTypes = (query, page) => {
    return chatgenieAPI.getContactTypes({ query, page, normalizer: res => res.data });
  };

  const handleConfirmedDelete = () => {
    handleDeleteVariation(confirmDeleteData.variation);
    setConfirmDeleteData({ variation: null, isConfirming: false });
  };
  const handleGoBack = () => {
    history.push('/dashboard/magic/agent');
  };

  const handleTemplateSubmit = template => {
    history.push({
      pathname: history.location.pathname,
      state: { template }
    });
    setTemplateModalOpen(false);
  };

  const handleTemplateOpen = () => {
    setTemplateSwitchModalOpen(false);
    setTemplateModalOpen(true);
  };

  const handleTemplateSwitchWarning = () => {
    setTemplateSwitchModalOpen(true);
  };

  const handleTemplateClose = () => {
    setTemplateModalOpen(false);
  };

  return (
    <PageWrapper
      titleComponent={
        <TitleInput
          value={data.name}
          placeholder="Intent name"
          onChange={e => handleTitleChange(e.target.value)}
        />
      }
      title="Agent intent"
      padding={0}
      isBackButton
      tools={
        <ToolsStyled>
          <Switcher
            id="intent-status"
            checked={!!data.is_active}
            onChange={() => {
              handleIsActive(!data.is_active);
            }}
            controlText={{ checked: 'ON', unchecked: 'OFF' }}
          />
          <SimpleButton isLoader={isUpserting} form="intent-form">
            Save
          </SimpleButton>
        </ToolsStyled>
      }
      onBackButtonClick={() => {
        if (isDirty) {
          setUnsavedModalOpen(true);
        } else {
          handleGoBack();
        }
      }}
    >
      {isLoading ? (
        <PageHolder fullHeight isLoading />
      ) : (
        <IntentContainer>
          <VariationList
            activeVariationId={variation?.id}
            variations={data?.variations}
            handleSelectVariation={handleSelectVariation}
            handleAddNewVariation={handleAddNewVariation}
            handleDeleteVariation={handleAttemptDelete}
            handleDuplicateVariation={handleDuplicateVariation}
          />
          <IntentWrapper id="intent-form" onSubmit={handleSubmit}>
            <VariationDetails
              isDefault={variation?.is_default}
              visibilityScope={variation?.visibility_scope}
              clients={variation?.clients}
              companyTypes={variation?.company_types}
              contactTypes={variation?.contact_types}
              parentCompanies={variation?.parent_companies}
              topLevels={variation?.top_levels}
              name={variation?.name}
              isActive={variation?.is_active}
              description={data?.description}
              timeSaved={data.time_saved}
              handleDescriptionChange={handleDescriptionChange}
              handleVariationNameChange={handleVariationNameChange}
              handleVisibilityScopeChange={handleVisibilityScopeChange}
              handleClientsChange={handleClientsChange}
              handleCompanyTypesChange={handleCompanyTypesChange}
              handleContactTypesChange={handleContactTypesChange}
              handleParentCompaniesChange={handleParentCompaniesChange}
              handleTopLevelsChange={handleTopLevelsChange}
              handleTemplateOpen={handleTemplateSwitchWarning}
              handleTimeSavedChange={handleTimeSavedChange}
              handleVariationToggle={handleVariationToggle}
            />
            <SeparatorStyled withTopOffset>
              <DownArrow />
            </SeparatorStyled>
            <VariationArguments
              variationArguments={variation?.arguments}
              handleAddFormField={handleAddFormField}
              handleRemoveArgument={handleRemoveArgument}
              handleChangeFormField={handleChangeFormField}
              handleChangeArgumentOrder={handleChangeArgumentOrder}
            />
            <SeparatorStyled>
              <DownArrow />
            </SeparatorStyled>
            <ApprovalIntentBlock show={isApprovalsEnabled}>
              <IntentBlock>
                <ApprovalIntentWrapper>
                  <ApprovalIntentField>
                    <p>Needs approval?</p>
                    <Switcher
                      width={50}
                      checked={variation?.approval?.is_active}
                      controlText={{ checked: '', unchecked: '' }}
                      onChange={() => handleChangeApproval(!variation?.approval?.is_active)}
                    />
                  </ApprovalIntentField>
                  <ApprovalIntentContactTypes show={variation?.approval?.is_active}>
                    <ApprovalIntentField>
                      <p>Contact types</p>
                      <ApprovalContactTypeSelectWrapper>
                        <CustomMultiSelect
                          name="approval-contact-types"
                          onChange={value => handleApprovalsCompanyTypes(value)}
                          value={variation?.approval?.contact_types}
                          options={getContactTypes}
                          componentType="paginate"
                        />
                      </ApprovalContactTypeSelectWrapper>
                    </ApprovalIntentField>
                  </ApprovalIntentContactTypes>
                </ApprovalIntentWrapper>
              </IntentBlock>
              <SeparatorStyled>
                <DownArrow />
              </SeparatorStyled>
            </ApprovalIntentBlock>
            <IntentBlock>
              <IntentReply
                type="external"
                data={externalReply}
                onChange={replyData => handleReplyContentChange('external', replyData)}
              />
            </IntentBlock>
            <SeparatorStyled>
              <DownArrow />
            </SeparatorStyled>
            <IntentBlock>
              <IntentReply
                type="internal"
                data={internalReply}
                onChange={replyData => handleReplyContentChange('internal', replyData)}
              />
            </IntentBlock>
            <SeparatorStyled>
              <DownArrow />
            </SeparatorStyled>
            <Automation
              handleChangeAutomation={handleChangeAutomation}
              url={variation?.url}
              method={variation?.method}
              headers={variation?.headers}
            />
          </IntentWrapper>
          <ChatWrapper />
        </IntentContainer>
      )}
      <ConfirmModal
        isOpen={confirmDeleteData.isConfirming}
        toggleHandler={() => setConfirmDeleteData({ variation: null, isConfirming: false })}
        title="Delete variation"
        description={<span>Are you sure you want to delete this variation?</span>}
        modalType="error"
        cancelText="Cancel"
        submitText="Yes"
        onSubmit={handleConfirmedDelete}
      />
      <ConfirmModal
        isOpen={unsavedModalOpen}
        toggleHandler={() => setUnsavedModalOpen(!unsavedModalOpen)}
        title="You have not saved your intent"
        description={
          <span>
            If you leave the page, you will lose your changes.
            <br />
            Are you sure you want to leave?
          </span>
        }
        modalType="error"
        submitText="Yes"
        onSubmit={handleGoBack}
      />
      <ConfirmModal
        isOpen={templateSwitchModalOpen}
        toggleHandler={() => setTemplateSwitchModalOpen(!templateSwitchModalOpen)}
        title="Are you sure you want to switch to template?"
        description={<span>This might overwrite any edits you have made.</span>}
        modalType="error"
        submitText="Yes"
        onSubmit={handleTemplateOpen}
      />
      <IntentTemplatesModal
        isOpen={templateModalOpen}
        onClose={handleTemplateClose}
        onSubmit={handleTemplateSubmit}
      />
    </PageWrapper>
  );
};
export default IntentScreen;
